import React, { memo, useCallback } from 'react';
import { FiSearch } from 'react-icons/fi';
import { useDocumentation } from '../../contexts/DocumentationContext';
import documentationData from '../../data/documentationData';

const SearchBox = memo(function SearchBox() {
  const {
    searchQuery,
    handleSearch,
    searchResults,
    isSearching,
    navigateToSearchResult,
    setSearchResults
  } = useDocumentation();
  
  const performSearch = useCallback((query) => {
    handleSearch(query);
    
    if (query.length < 2) {
      return;
    }
    
    const results = [];
    // Use direct object access instead of iterations for better performance
    for (const sectionId of documentationData.sectionOrder) {
      const section = documentationData.sections[sectionId];
      
      if (section.title.toLowerCase().includes(query.toLowerCase())) {
        results.push({
          id: section.id,
          title: section.title,
          type: 'section',
          snippet: `Main section for ${section.title}`
        });
      }
      
      for (const subsectionId in section.subsections) {
        const subsection = section.subsections[subsectionId];
        if (subsection.title.toLowerCase().includes(query.toLowerCase())) {
          results.push({
            id: `${section.id}-${subsection.id}`,
            title: subsection.title,
            type: 'subsection',
            section: section.title,
            sectionId: section.id,
            subsectionId: subsection.id,
            snippet: `${subsection.title} under ${section.title}`
          });
        }
      }
    }
    
    setSearchResults(results);
  }, [handleSearch, setSearchResults]);
  
  return (
    <div className="docs-search">
      <input
        type="text"
        placeholder="Search documentation..."
        value={searchQuery}
        onChange={(e) => performSearch(e.target.value)}
      />
      <FiSearch className="search-icon" />
      
      {isSearching && searchQuery.length >= 2 && (
        <div className="search-results">
          {searchResults.length > 0 ? (
            searchResults.map((result, index) => (
              <div
                key={index}
                className="search-result-item"
                onClick={() => navigateToSearchResult(result)}
              >
                <div className="search-result-title">{result.title}</div>
                <div className="search-result-snippet">{result.snippet}</div>
              </div>
            ))
          ) : (
            <div className="search-no-results">No results found</div>
          )}
        </div>
      )}
    </div>
  );
});

export default SearchBox;